import { render, staticRenderFns } from "./PraticaDetailPage.vue?vue&type=template&id=16d5e8f1&"
import script from "./PraticaDetailPage.vue?vue&type=script&lang=js&"
export * from "./PraticaDetailPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16d5e8f1')) {
      api.createRecord('16d5e8f1', component.options)
    } else {
      api.reload('16d5e8f1', component.options)
    }
    module.hot.accept("./PraticaDetailPage.vue?vue&type=template&id=16d5e8f1&", function () {
      api.rerender('16d5e8f1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/views/PraticaDetailPage.vue"
export default component.exports